export enum GlobalRoutes {
  HOME = '/',
  LOGOUT = '/logout',
}
